cv.CustomFieldsRowView = Marionette.LayoutView.extend({
  tagName : 'div',
  className: 'form-group',

  template : cv.Templates['global/custom_fields_form/custom_fields_row'],

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications: true
  }],

  events : {
    'dropField' : 'drop',
    'click .edit-field a' : 'editField',
    'click .delete-field a' : 'deleteField'
  },

  modelEvents: {
    'change': 'render'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.validation = {};
    if(_.isUndefined(this.model.get('random_id'))){
      this.random_id = Math.floor(Math.random() * 10000);
    }else{
      this.random_id = this.model.get('random_id');
    }
    
    // Set the validations
    if(this.options.edit_mode == false){
      if(this.model.get('required') == 1){
        if(this.model.get('type') == 'checkbox'){
          // Make note of require check
          this.validation['field_value_' + this.random_id] = [{
            requireCheck : 'true',
            msg : "Required"
          }];
        }else{
          this.validation['field_value_' + this.random_id] = [{
            required : 'true',
            msg : "Required"
          }];
        }
      }else{
        this.validation['field_value_' + this.random_id] = [];
      }

      // Set the random ID
      this.model.set({'random_id' : this.random_id}, { silent: true });

      // Set a default value if it exists
      var has_field_value = false;
      _.each(this.model.attributes, function(item, key, list){
        if(key.substring(0, 12) == 'field_value_'){
          has_field_value = true;
        }
      }, this);
      if(has_field_value == false){
        // If we have some submitted values, then check if we have a value for it
        if(_.has(this.options.values, this.model.get('id'))){
          var field_value = this.options.values[this.model.get('id')];
        }else{
          var field_value = '';
        }
        if(this.model.get('type') == 'checkbox'){
          if(this.model.get('checked') == 1){
            this.model.set('field_value_' + this.random_id, 1);
          }else{
            this.model.set('field_value_' + this.random_id, field_value);
          }
        }else if(this.model.get('type') == 'radio'){
          if(this.model.get('default_values') != '' && field_value == ''){
            this.model.set('field_value_' + this.random_id, JSON.parse(this.model.get('default_values'))[0].value); 
          }else{
            this.model.set('field_value_' + this.random_id, field_value);
          }
        }else{
          this.model.set('field_value_' + this.random_id, field_value);
        }
      }
    }

    // View modes
    this.listenTo(vent, 'custom_field:edit_form', function(){
      this.edit_form = true;
    }, this);
    this.listenTo(vent, 'custom_field:preview_form', function(){
      this.edit_form = false;
    }, this);

    // Collection listeners
    this.listenTo(this.model.collection, 'add remove', function(){
      if(this.model.collection.length == 1){
        this.$('.delete-field').hide();
      }else{
        this.$('.delete-field').show();
      }
    }, this);

    console.log('CustomFieldRowView initialized');
  },

  templateHelpers : function(){
    return {
      is_text_line : this.model.get('type') == 'text_line' ? true : false,
      is_text_block : this.model.get('type') == 'text_block' ? true : false,
      is_select : this.model.get('type') == 'select' ? true : false,
      is_radio : this.model.get('type') == 'radio' ? true : false,
      is_checkbox : this.model.get('type') == 'checkbox' ? true : false,
      is_required : this.model.get('required') == 1 ? true : false,
      random_id : this.random_id,
      label : this.model.get('label'),
      default_values : this.model.get('default_values') == '' ? [] : JSON.parse(this.model.get('default_values')),
      has_help_text : this.model.get('help_text') != '' ? true : false,
      help_text : this.model.get('help_text'),
      is_edit_mode : this.options.edit_mode,
      is_nested : this.options.nested,
      is_donation_form : this.options.is_donation_form
    }
  },

  drop: function(event, index) {
    this.$el.trigger('update-field-sort', [this.model, index]);
  },

  editField: function(e){
    e.preventDefault();

    var view = new cv.EditCustomFieldView({
      edit_field : true,
      model : this.model
    });
    vent.trigger('modal:show', view);

    this.listenTo(view, 'form:saved', function(){
      vent.trigger('modal:hide');
    }, this);
  },

  deleteField: function(e){
    e.preventDefault();

    // Load the modal
    var view = new cv.ConfirmView({
      message : 'Are you sure you want to delete this field.  You may lose data associated with this field.'
    });
    vent.trigger('modal:show', view);

    view.on('confirm', function(){
      this.model.collection.remove(this.model);
    }, this);
  },

  onAttach: function(){
    if(this.model.collection.length == 1){
      this.$('.delete-field').hide();
    }
  },

  onRender: function(){
    // Add data-bypass to links
    this.$('a').attr('data-bypass', true);
    
    // Reset the form with validations
    this.trigger('form:reset');
  },

  onDestroy: function(){
    vent.trigger('custom_field:unlink_field', this);
  }
});
